import React from 'react'
import { COUNTER } from '../../../../Utilities/APIs'
import useFetch from '../../../../Utilities/Hooks/useFetch'
import EngtoBang from 'engnumber-to-banglanumber'

import './Counter.css'
import { useSelector } from 'react-redux'

function Counter() {
    const [data, loading] = useFetch(COUNTER, 'true')
    const { consumer } = useSelector(state => state.auth)

    return (
        <section className="sc_counter">
            <div className="container">
                <div className="row">
                    {data?.map(data => (
                        <div className="counter" key={data._id}>
                            <div className="counter_content">
                                <h2 className='counter_number'>
                                    {
                                        consumer
                                            ?
                                            consumer.language === 'english'
                                                ?
                                                `${data.amount} +`
                                                :
                                                `${EngtoBang(data.amount)} +`
                                            :
                                            `${EngtoBang(data.amount)} +`
                                    }
                                </h2>
                                <h3 className='counter_title'>
                                    {
                                        consumer
                                            ?
                                            consumer.language === 'english'
                                                ?
                                                data.engName
                                                :
                                                data.name
                                            :
                                            data.name
                                    }
                                </h3>
                            </div>
                        </div>
                    ))}
                    {loading ? '...loading' : ''}
                </div>
            </div>
        </section>
    )
}

export default Counter